import { PageHero } from "../components/common/PageHero";
import { ConstructionSection } from "../components/sections/ConstructionSection";
import { ConstructionForm } from "../components/forms/ConstructionForm";
import { SectionHeading } from "../components/common/SectionHeading";
import { images } from "../data/content";

export default function Construction() {
    return (
        <>
            <PageHero
                overline="Construction Services"
                breadcrumb="Construction"
                title="Construction & Project Execution Services"
                subtitle="From Workforce to Project Execution — One Integrated Partner. Civil construction, infrastructure, industrial support and finishing works, backed by skilled construction workforce."
                image={images.construction}
            />
            <ConstructionSection full />
            <section className="relative bg-[#f8fafc]" id="construction-enquiry" data-testid="construction-enquiry">
                <div className="mx-auto max-w-[1100px] px-5 lg:px-10 py-24 lg:py-32">
                    <SectionHeading
                        overline="Project Enquiry"
                        title="Request a Construction Quote"
                        subtitle="Share your project details and our team will get back with a tailored proposal."
                        align="center"
                    />
                    <div className="mt-12 bg-white border border-slate-200 rounded-sm p-6 lg:p-10">
                        <ConstructionForm />
                    </div>
                </div>
            </section>
        </>
    );
}
